<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <strong>A communal experience designed to promote socializing, in a setting with architectural nods to Cincinnati’s rich history. Elevated a la carte food and beverage offerings pair with covered, sideline lower level seats.</strong>
        <p class="map">
          <img
            src="~@/assets/maps/map-cincinnatus.png"
            alt
            data-aos="zoom-in-up"
            data-aos-duration="250"
            data-aos-easing="ease-out-cubic"
          />
        </p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy
  },
  mounted() {
    const ref = this.$store.state.menu.cincinnatusClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.cincinnatusClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.cincinnatusClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Cincinnatus Club",
      h3: "Intro"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cincinnatus-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>